export const MY_PRODUCTS = "My Products"
export const NO_CONNECTORS = " You don't have any Products to show, Please click on New connector Button and Follow the process to create Connector."
export const NO_BUSSINESS_ENTITY = 'There are no entities';
export const NO_ENTITY_DATA = 'There is no data to show';
export const setupStatus = "Setup Incomplete"
export const featuerWarning = "Select all fields to get Features "
export const noFeatuer = "We are still updating features for your selection, Meanwhile you can continue the process."
export const setupWarning = "Installation setup incomplete. To complete the installation process, Please download installers / Click on setup button, and continue installation process."
export const noData = "No data found related to your selection"
export const setupCompleted = "Please click on Finish Setup, Once done with Download and Setup process."
export const entityHeading = {
    mainHeading: "Manage Entities",
    subHeading: "Manage data flow direction and status",
    entityName: "Entity",
    targetToSource: "eCommerce to ERP",
    sourceToTarget: "ERP to eCommerce",
    packetSize: "Packet Size",
    lastUpdate: "Last Update"
}

const BI_DASHBOARD_URL_BY_HOST = {
    'clouddev2.i95-dev.com': 'https://bidev.i95-dev.com'
}

const currentHost = typeof window !== 'undefined' ? window.location.hostname : ''

export const BI_DASHBOARD_URL = (BI_DASHBOARD_URL_BY_HOST[currentHost] || process.env.REACT_APP_BI_DASHBOARD_URL || 'http://localhost:3001').replace(/\/+$/, '')


